import moment from "moment";
import {
  AddressInput,
  DatePicker,
  FileUploader,
  InputText,
  PhoneNumberField,
} from "../../components";
import { useFormContext } from "react-hook-form";
import { RootState } from "../../store/root-reducer";
import { useDispatch, useSelector } from "react-redux";
import { uploadClaimImage } from "../../store/mattress-claim/actions";

function PurchaseInfo() {
  const { control, setValue } = useFormContext();
  const claim = useSelector((state: RootState) => state.claim);
  const dispatch = useDispatch();

  return (
    <div className="space-y-3">
      <InputText
        control={control}
        name="purchaseInfo.store_purchase"
        required
        label="Store of Purchase"
      />
      <PhoneNumberField
        control={control}
        name="purchaseInfo.retailer_phone"
        required
        label="Retailer Phone"
      />
      <AddressInput
        control={control}
        name="purchaseInfo.address1"
        onAddressSelect={(address) => {
          setValue("purchaseInfo.city", address.city);
          setValue("purchaseInfo.state", address.state);
          setValue("purchaseInfo.zip", address.zipCode);
        }}
        required
        label="Address 1"
      />
      <InputText
        label={"Address 2"}
        control={control}
        name={"purchaseInfo.address2"}
      />
      <InputText
        label={"City"}
        control={control}
        name={"purchaseInfo.city"}
        required
      />
      <InputText
        label={"State"}
        control={control}
        name={"purchaseInfo.state"}
        required
      />
      <InputText
        label={"Zip"}
        control={control}
        name={"purchaseInfo.zip"}
        required
      />
      <DatePicker
        label={"Purchase Date"}
        control={control}
        name={"purchaseInfo.purchase_date"}
        required
        rules={{
          validate: (selectedDate) => {
            const diffYears = moment(selectedDate, "YYYY-MM-DD").diff(
              new Date(),
              "years"
            );
            return (
              diffYears > -10 ||
              "Claims are only accepted within 10 years of purchase"
            );
          },
        }}
      />
      <FileUploader
        control={control}
        name="purchaseInfo.invoice_image"
        label="Copy of your invoice"
        required
        uploadedFiles={
          claim.purchaseInfo.invoice_image
            ? [claim.purchaseInfo.invoice_image]
            : []
        }
        onFileSelect={(files) =>
          dispatch(
            uploadClaimImage({
              files,
              storeKeyName: "purchaseInfo.invoice_image",
            })
          )
        }
      />
    </div>
  );
}

export default PurchaseInfo;
